import { IconButton, OutlinedInput, Stack } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";

export interface KeyDriveCounterProps {
  value: number;
  onChange: (value: number) => void;
  min?: number;
  max?: number;
  disabled?: boolean;
}

const KeyDriveCounter = ({
  value,
  onChange,
  min = 1,
  max,
  disabled,
}: KeyDriveCounterProps) => {
  const handleDecrement = () => {
    if (min !== undefined && value <= min) return;
    onChange(value - 1);
  };

  const handleIncrement = () => {
    if (max !== undefined && value >= max) return;
    onChange(value + 1);
  };

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const parsed = parseInt(e.target.value);
    if (isNaN(parsed)) return;
    if (min !== undefined && parsed < min) return;
    if (max !== undefined && parsed > max) return;
    onChange(parsed);
  };

  const atMin = min !== undefined && value <= min;
  const atMax = max !== undefined && value >= max;

  return (
    <Stack
      direction="row"
      alignItems="center"
      sx={{
        border: "0.5px solid",
        borderColor: "divider",
        borderRadius: 1,
        overflow: "hidden",
        width: "100%",
      }}
    >
      <IconButton
        onClick={handleDecrement}
        disabled={disabled || atMin}
        disableRipple
        sx={{
          borderRadius: 0,
          width: 48,
          height: 44,
          flexShrink: 0,
          borderRight: "0.5px solid",
          borderColor: "divider",
          "&:hover": { backgroundColor: "action.hover" },
        }}
      >
        <RemoveIcon fontSize="small" />
      </IconButton>

      <OutlinedInput
        value={value}
        onChange={handleInputChange}
        disabled={disabled}
        inputProps={{
          min,
          max,
          style: { textAlign: "center", padding: 0 },
        }}
        sx={{
          flex: 1,
          height: 44,
          fontSize: 16,
          "& fieldset": { border: "none" },
          "& input": {
            textAlign: "center",
            height: 44,
            boxSizing: "border-box",
          },
        }}
      />

      <IconButton
        onClick={handleIncrement}
        disabled={disabled || atMax}
        disableRipple
        sx={{
          borderRadius: 0,
          width: 48,
          height: 44,
          flexShrink: 0,
          borderLeft: "0.5px solid",
          borderColor: "divider",
          "&:hover": { backgroundColor: "action.hover" },
        }}
      >
        <AddIcon fontSize="small" />
      </IconButton>
    </Stack>
  );
};

export default KeyDriveCounter;